import { AssortmentTypes } from '@retail/calculus/types';
import { ToggleGroup, ToggleGroupOption } from '@retail/components';
import { MyAssortmentTFunction, useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { useMemo } from 'react';

interface Props {
  assortmentType: AssortmentTypes;
  setAssortmentType: (newView: AssortmentTypes) => void;
}

export const StatusToggleButton = ({ assortmentType, setAssortmentType }: Props) => {
  const t = useMyAssortmentTFunction();

  const options: ToggleGroupOption<AssortmentTypes>[] = useMemo(
    () => [
      { label: t('myAssortment.filter.active'), value: 'BASE' },
      { label: t('myAssortment.filter.drafted'), value: 'DRAFT' },
      { label: t('myAssortment.filter.all'), value: 'DRAFT_AND_BASE' },
    ],
    [t]
  );

  return (
    <ToggleGroup
      variant="pill"
      label={t('myAssortment.status.status')}
      labelDirection="vertical"
      options={options}
      fullWidth
      value={assortmentType ?? 'BASE'}
      onChange={setAssortmentType}
      size="small"
    />
  );
};

export const getAssortmentTypeText = (
  t: MyAssortmentTFunction,
  conditionState?: AssortmentTypes
) => {
  switch (conditionState) {
    case 'BASE':
      return t('myAssortment.filter.active');
    case 'DRAFT':
      return t('myAssortment.filter.drafted');
    case 'DRAFT_AND_BASE':
      return t('myAssortment.filter.all');
    default:
      return '';
  }
};
